var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.88 9.73C27.085 9.195 27.2 8.61 27.2 8C27.2 5.35 25.05 3.2 22.4 3.2C21.415 3.2 20.495 3.5 19.735 4.01C18.35 1.61 15.765 0 12.8 0C8.38 0 4.8 3.58 4.8 8C4.8 8.135 4.805 8.27 4.81 8.405C2.01 9.39 0 12.06 0 15.2C0 19.175 3.225 22.4 7.2 22.4H25.6C29.135 22.4 32 19.535 32 16C32 12.905 29.8 10.32 26.88 9.73ZM19.67 12.8H16.4V18.4C16.4 18.84 16.04 19.2 15.6 19.2H13.2C12.76 19.2 12.4 18.84 12.4 18.4V12.8H9.13C8.415 12.8 8.06 11.94 8.565 11.435L13.835 6.165C14.145 5.855 14.655 5.855 14.965 6.165L20.235 11.435C20.74 11.94 20.38 12.8 19.67 12.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDocuments);
export default __webpack_public_path__ + "static/media/upload-documents.5c29d77bfcd797c7b27b843172912094.svg";
export { ForwardRef as ReactComponent };